import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisV,
  faTable,
  faCaretUp,
  faCaretDown,
  faFilePdf,
} from "@fortawesome/free-solid-svg-icons";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {
  BodyAsFormData,
  noDataForGraph,
  exceldataFormate,
} from "../../../services/utilities/util";
import { JsonToExcel } from "react-json-to-excel";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import { Line } from "react-chartjs-2";
import "jspdf-autotable";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class AssetCustom extends React.Component {
  static contextType = FilterContext;

  state = {
    noGraph: false,
    showLoader: false,
    showGraph: false,
    asset: {},
    rentAndSecurity: {},
    filters: "",
    tooltipClassname: null,
    tooltipArrow: faCaretUp,
    tooltipArrowDisplay: "none",
    tooltipYLabel: null,
    tooltipxLabel: null,
    chartOtions: {},
    exceldata: [],
    chartData: {
      labels: [],
      datasets: [],
    },
  };

  componentDidMount() {
    this.setState({ showLoader: true, showGraph: false });
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    this.setState({});
    apiMiddleware
      .post(
        "api/edge/office/get_custom_vs_asset_lease_parameters",
        BodyAsFormData(filters)
      )
      .then((res) => {
        this.setState({ asset: res.data }, () => {
          console.log(this.state.asset);
        });
      });

    apiMiddleware
      .post(
        "api/edge/office/get_custom_vs_asset_charges",
        BodyAsFormData(filters)
      )
      .then((res) => {
        if (res.data) {
          this.setState({ rentAndSecurity: res.data }, () => {
            console.log(this.state.rentAndSecurity);
          });
        }
      });
    if (this.state.isLoad && !this.state.noGraph) {
      const ctx = document
        .getElementById("rentalsVacancyLineChart")
        .getContext("2d");
      let gradient = ctx.createLinearGradient(0, 0, 0, 400);
      gradient.addColorStop(0, "rgba(113,206,250, 1)");
      gradient.addColorStop(1, "#cce9ff");
    }

    const superClass = this;
    const options = {
      responsive: true,
      scales: {
        x: {
          grid: {
            display: false,
          },
          title: {
            display: true,
            text: "",
          },
          ticks: {
            autoSkip: false,
            color: "black",
            font: {
              size: 10,
            },
          },
        },
        y: {
          beginAtZero: true,
          grid: {
            display: true,
            drawBorder: true,
          },
          title: {
            display: true,
            text: "₹ / sqft / month",
          },
        },
      },
      plugins: {
        legend: {
          display: true,
        },
        title: {
          display: false,
        },
        tooltip: {
          enabled: true,
          y: "bottom",
          backgroundColor: "#000",
          external: function (context) {
            if (
              (typeof context.tooltip.dataPoints[0].parsed.y !== "undefined" &&
                context.tooltip.dataPoints[0].parsed.y !==
                  superClass.state.tooltipYLabel) ||
              (typeof context.tooltip.dataPoints[0].label !== "undefined" &&
                context.tooltip.dataPoints[0].label !==
                  superClass.state.tooltipxLabel)
            ) {
              superClass.setState({
                tooltipClassname: "colorRed",
                tooltipArrow: faCaretDown,
                tooltipArrowDisplay: "",
                tooltipYLabel: context.tooltip.dataPoints[0].parsed.y,
                tooltipxLabel: context.tooltip.dataPoints[0].label,
              });
            }
          },
        },
      },
    };

    apiMiddleware
      .post(
        "api/edge/office/get_custom_vs_asset_rentals",
        BodyAsFormData(filters)
      )
      .then((res) => {
        this.setState({ showLoader: false, showGraph: true });
        let data = {
          labels: res.data.x,
          datasets: [
            {
              label: res.data.legend.y1,
              data: res.data.datapoints.y1,
              borderColor: res.data.bgcolor.y1,
              backgroundColor: res.data.bgcolor.y1,
            },
            {
              label: res.data.legend.y2,
              data: res.data.datapoints.y2,
              borderColor: res.data.bgcolor.y2,
              backgroundColor: res.data.bgcolor.y2,
            },
          ],
        };

        if (
          noDataForGraph(res.data.datapoints.y1) ||
          noDataForGraph(res.data.datapoints.y2)
        ) {
          superClass.setState({
            noGraph: false,
          });
        } else {
          superClass.setState({
            noGraph: true,
          });
        }
        const excelData = exceldataFormate(res);

        superClass.setState({
          chartOtions: options,
          chartData: data,
          exceldata: excelData,
        });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters){
      this.setState({ filters: this.props.filters });

      apiMiddleware
        .post(
          "api/edge/office/get_custom_vs_asset_lease_parameters",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.setState({ asset: res.data }, () => {
            console.log(this.state.asset);
          });
        });

      apiMiddleware
        .post(
          "api/edge/office/get_custom_vs_asset_charges",
          BodyAsFormData(JSON.stringify(this.context.filters))
        )
        .then((res) => {
          this.setState({ rentAndSecurity: res.data }, () => {
            console.log(this.state.rentAndSecurity);
          });
        });
    }
  }
  downloadPdf() {
    const input = document.getElementById("rentalComparison");
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHight);
      pdf.save("rentalComparison.pdf");
    });
  }

  render() {
    return (
      <div className="container-fluid unitsRents assets" id="rentalComparison">
        {this.state.showLoader && (
          <div className="row">
            <div className="col-lg-12 text-center">
              <img src="/edge/images/edgeLoader.gif" />
            </div>
          </div>
        )}
        {!this.state.showLoader && this.state.noGraph && (
          <div className="row">
            <div className="col-lg-12 text-center">
              <img src="/edge/images/NoGraph-01.png" className="w100" />
            </div>
          </div>
        )}
        {this.state.showGraph && !this.state.noGraph && (
          <div className="row">
            <div className="col-lg-12 mb-4">
              <div className="widget widgetGraph">
                <div className="row">
                  <div className="col-lg-9 text-start colorLightBlue">
                    <p>Rental Comparison</p>
                    <h4 className={this.state.tooltipClassname}>
                      <FontAwesomeIcon
                        icon={this.state.tooltipArrow}
                        style={{ display: this.state.tooltipArrowDisplay }}
                      />
                      {this.state.tooltipYLabel} &nbsp;
                    </h4>
                    <p className="colorBlack pSmall">
                      {this.state.tooltipxLabel}&nbsp;
                    </p>
                  </div>
                  <div className="col-lg-3 text-end">
                    <p className="colorBlack downloads">
                      <FontAwesomeIcon icon={faEllipsisV} />
                      <ul className="downloadOptions">
                        <li
                          className="pdfDownload"
                          onClick={(e) => {
                            this.downloadPdf();
                          }}
                        >
                          <FontAwesomeIcon icon={faFilePdf} /> Download as PDF
                        </li>

                        <li className="pdfDownload">
                          <JsonToExcel
                            title="Download as Excel"
                            data={this.state.exceldata}
                            fileName="rentalComparison"
                            btnClassName="graphExcelDownloadBtn"
                          />
                        </li>
                      </ul>
                    </p>
                  </div>
                  <div className="col-lg-12">
                    <Line
                      id="rentalsVacancyLineChart"
                      options={this.state.chartOtions}
                      data={this.state.chartData}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="tabDetails">
                <h6 className="text-left mb-4">Rental Comparison</h6>
                <table className="table table-striped">
                  <tbody>
                    <tr>
                      <td>Lease Term</td>
                      <td>
                        {this.state.asset.asset !== undefined
                          ? this.state.asset.asset.lease_term
                          : "-"}
                      </td>
                      <td>
                        {this.state.asset.lease !== undefined
                          ? this.state.asset.lease.lease_term
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td>Rent free Period</td>
                      <td>
                        {this.state.asset.asset !== undefined
                          ? this.state.asset.asset.rentfree_period
                          : "-"}
                      </td>
                      <td>
                        {this.state.asset.lease !== undefined
                          ? this.state.asset.lease.rentfree_period
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td>Lock-in Period</td>
                      <td>
                        {this.state.asset.asset !== undefined
                          ? this.state.asset.asset.lockin_period
                          : "-"}
                      </td>
                      <td>
                        {this.state.asset.lease !== undefined
                          ? this.state.asset.lease.lockin_period
                          : "-"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="tabDetails">
                <h6 className="text-left mb-4">Rent & Security Deposit</h6>
                <table className="table table-striped">
                  <tbody>
                    <tr>
                      <td>Avg. Escalation</td>
                      <td>
                        {this.state.rentAndSecurity.asset !== undefined
                          ? this.state.rentAndSecurity.asset.rent_escalation
                          : "-"}
                      </td>
                      <td>
                        {this.state.rentAndSecurity.lease !== undefined
                          ? this.state.rentAndSecurity.lease.rent_escalation
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td>Security Deposit</td>
                      <td>
                        {this.state.rentAndSecurity.asset !== undefined
                          ? this.state.rentAndSecurity.asset.security_deposit
                          : "-"}
                      </td>
                      <td>
                        {this.state.rentAndSecurity.lease !== undefined
                          ? this.state.rentAndSecurity.lease.security_deposit
                          : "-"}
                      </td>
                    </tr>
                    <tr>
                      <td>CAM Charges</td>
                      <td>
                        {this.state.rentAndSecurity.asset !== undefined
                          ? this.state.rentAndSecurity.asset.cam_charges
                          : "-"}
                      </td>
                      <td>
                        {this.state.rentAndSecurity.lease !== undefined
                          ? this.state.rentAndSecurity.lease.cam_charges
                          : "-"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(AssetCustom);
